import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { useConfigContext } from "@/contexts";

export function Auth0ProviderWithConfig({ children }) {
  const { auth0 } = useConfigContext();
  const navigate = useNavigate();

  if (import.meta.env.DEV) {
    console.log("auth0", auth0);
  }

  return (
    <Auth0Provider
      domain={auth0.domain}
      clientId={auth0.clientId}
      onRedirectCallback={(appState) => {
        navigate(appState?.returnTo || "/", { replace: true });
      }}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: auth0.audience,
        scope: "openid profile email",
      }}
      cacheLocation="memory"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
      {children}
    </Auth0Provider>
  );
}
